export function updateSpecialization(specialization) {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_SPECIALIZATION',
      specialization,
    })
  }
}
